'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'trash-check';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e2af';
var svgPathData = ['M43.6 128l360.8 0-24 323.5c-1.9 25.1-22.7 44.5-47.9 44.5l-217.1 0c-25.1 0-46-19.4-47.9-44.5L43.6 128zm86.9 174.6c-3.2 3.1-3.3 8.1-.2 11.3l62.3 64.5c1.6 1.7 4 2.6 6.3 2.4s4.5-1.4 5.9-3.3L318.6 221.1c2.6-3.6 1.8-8.6-1.8-11.2-3.6-2.6-8.6-1.8-11.2 1.7l-108.1 148.7-55.7-57.6c-3.1-3.2-8.1-3.3-11.3-.2zM131.8 64l19.6-48.9C155 6 163.8 0 173.7 0L274.3 0c9.8 0 18.6 6 22.3 15.1L316.2 64 131.8 64z', 'M67.6 451.5c1.9 25.1 22.7 44.5 47.9 44.5l217.1 0c25.1 0 46-19.4 47.9-44.5l24-323.5 16 0-24.1 324.7c-2.5 33.4-30.3 59.3-63.8 59.3l-217.1 0c-33.5 0-61.4-25.9-63.8-59.3l-24-324.7 16 0 24 323.5zM305.7 211.7c2.6-3.6 7.6-4.3 11.2-1.7 3.6 2.6 4.3 7.6 1.8 11.2L204.9 377.5c-1.4 1.9-3.6 3.1-5.9 3.3s-4.7-.7-6.3-2.4l-62.3-64.5c-3.1-3.2-3-8.2 .2-11.3s8.2-3 11.3 .2l55.7 57.6 108.1-148.7zM274.3-16c16.4 0 31.1 10 37.1 25.2L333.4 64 440 64c4.4 0 8 3.6 8 8s-3.6 8-8 8L8 80c-4.4 0-8-3.6-8-8s3.6-8 8-8l106.6 0 21.9-54.8C142.6-6 157.3-16 173.7-16l100.7 0zM173.7 0c-9.8 0-18.6 6-22.3 15.1L131.8 64 316.2 64 296.6 15.1C293 6 284.2 0 274.3 0L173.7 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTrashCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;